type TProjectRef = { projectId: number; databaseId: number };

export const createExtractionExit = ({
    getSearch,
    isSafeReturnUrl,
    redirectTo,
    toDealDocuments,
}: {
    getSearch: () => string;
    isSafeReturnUrl: (url: string) => boolean;
    redirectTo: (url: string) => void;
    toDealDocuments: (params: TProjectRef) => void;
}) => {
    const getValidReturnUrl = (): string | null => {
        const returnUrl = new URLSearchParams(getSearch()).get("returnUrl");
        return returnUrl !== null &&
            returnUrl !== "" &&
            isSafeReturnUrl(returnUrl)
            ? returnUrl
            : null;
    };

    const exit = (params: TProjectRef) => {
        const returnUrl = getValidReturnUrl();
        if (returnUrl === null) {
            toDealDocuments(params);
            return;
        }
        redirectTo(returnUrl);
    };

    const withReturnUrl = (path: string): string => {
        const returnUrl = getValidReturnUrl();
        return returnUrl === null
            ? path
            : `${path}?${new URLSearchParams({ returnUrl }).toString()}`;
    };

    const discardAndExit = async ({
        discard,
        ...params
    }: TProjectRef & { discard: () => Promise<unknown> }) => {
        try {
            await discard();
        } catch {
            return;
        }
        exit(params);
    };

    return { exit, withReturnUrl, discardAndExit };
};
